import type { ImgHTMLAttributes } from 'react';

import type { AssetResponse, DigizuiteAsset } from 'models/asset';

type ImgAttrs = Omit<ImgHTMLAttributes<HTMLImageElement>, 'alt' | 'src'>;

interface RegularProps extends ImgAttrs {
	alt: string | undefined | null;
	asset?: never;
	src: string | undefined;
}

// Allow overriding the alt text.
interface AssetProps extends ImgAttrs {
	alt?: string | undefined | null;
	asset: AssetResponse | DigizuiteAsset | undefined | null;
	src?: never;
}

type Props = RegularProps | AssetProps;

export default function IntrinsicSizeImg({
	alt: altProp,
	asset,
	height: heightProp,
	loading = 'lazy',
	src: srcProp,
	width: widthProp,
	...attrs
}: Props) {
	const src = srcProp ?? asset?.src;
	if (!src) {
		return null;
	}
	const height = heightProp ?? asset?.height;
	const width = widthProp ?? asset?.width;
	return (
		// oxlint-disable-next-line next/no-img-element
		<img
			{...attrs}
			src={src}
			alt={altProp ?? asset?.alt ?? ''}
			loading={loading}
			height={String(height) === '0' ? undefined : height}
			width={String(width) === '0' ? undefined : width}
		/>
	);
}
IntrinsicSizeImg.displayName = 'IntrinsicSizeImg';
